import React, { useState, useEffect } from "react";
import api from "../../api/axios";
import toast from "react-hot-toast";
import { Plus, Trash2, Search, ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
import { Link } from "react-router-dom";

export default function FaqListPage() {
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const pageSize = 10;

  const fetchFaqs = async () => {
    setLoading(true);
    try {
      const res = await api.get("/faq", {
        params: { page, size: pageSize, q: search, sort: "sortOrder:asc" },
      });
      setFaqs(res.data.items || res.data || []);
      setTotal(res.data.total || 0);
    } catch { toast.error("SSS verileri yüklenemedi"); }
    finally { setLoading(false); }
  };

  useEffect(() => { fetchFaqs(); }, [page, search]);

  const handleDelete = (id) => {
    if (!window.confirm("Bu SSS kaydını silmek istediğinize emin misiniz?")) return;
    api.delete(`/faq/${id}`)
      .then(() => { toast.success("SSS silindi"); fetchFaqs(); })
      .catch(() => toast.error("Silme başarısız"));
  };

  const totalPages = Math.ceil(total / pageSize);

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h2>Sıkça Sorulan Sorular</h2>
          <p className="page-subtitle">{total} kayıt</p>
        </div>
        <Link to="/faq-add" className="btn btn-primary"><Plus size={18} /> Yeni SSS</Link>
      </div>

      <div className="content-card">
        <div className="table-toolbar">
          <div className="search-box">
            <Search size={18} />
            <input
              type="text"
              placeholder="Ara..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setPage(1); }}
            />
          </div>
        </div>

        {loading ? (
          <div className="page-loading inline"><div className="loading-spinner" /></div>
        ) : (
          <>
            <div className="faq-list">
              {faqs.map((faq) => (
                <div key={faq.id} className="faq-item">
                  <div className="faq-content">
                    <div className="faq-order">#{faq.sortOrder}</div>
                    <div className="faq-text">
                      <h4>{faq.questionTr}</h4>
                      <p>{faq.answerTr ? (faq.answerTr.length > 120 ? faq.answerTr.substring(0, 120) + "..." : faq.answerTr) : ""}</p>
                    </div>
                  </div>
                  <button onClick={() => handleDelete(faq.id)} className="btn-icon delete"><Trash2 size={16} /></button>
                </div>
              ))}
            </div>

            {faqs.length === 0 && (
              <div className="empty-state">
                <p>Henüz SSS eklenmemiş</p>
                <Link to="/faq-add" className="btn btn-primary"><Plus size={18} /> İlk SSS'yi Ekle</Link>
              </div>
            )}

            {totalPages > 1 && (
              <div className="pagination">
                <button disabled={page === 1} onClick={() => setPage(page - 1)} className="btn-icon">
                  <ChevronLeft size={18} />
                </button>
                <span className="page-info">{page} / {totalPages}</span>
                <button disabled={page === totalPages} onClick={() => setPage(page + 1)} className="btn-icon">
                  <ChevronRight size={18} />
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}
